import React from 'react';
import PropTypes from 'prop-types';
import {
  HelpScoutLink,
  IconWrapper,
  ItemIcon,
  ItemLink,
  NavItemWrapper,
} from './styled';

const NavItem = ({ exact, icon, label, to }) => (
  <NavItemWrapper>
    <ItemLink exact={exact} to={to}>
      <IconWrapper>
        <ItemIcon icon={icon} />
      </IconWrapper>
      {label}
    </ItemLink>
  </NavItemWrapper>
);

NavItem.propTypes = {
  exact: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export const UpsellNavItem = ({
  icon,
  label,
  message,
  subject,
  ...unhandledProps
}) => (
  <NavItemWrapper>
    <HelpScoutLink
      message={message}
      subject={subject}
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...unhandledProps}
    >
      <IconWrapper>
        <ItemIcon icon={icon} />
      </IconWrapper>
      {label}
    </HelpScoutLink>
  </NavItemWrapper>
);

UpsellNavItem.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  message: PropTypes.string,
  subject: PropTypes.string,
};

export default NavItem;
